$(function() {

    const showMap = function() {
        const $this = $(this);
        const $target = $this.is('select') ? $this.find(":selected") : $this;
        const targetID = $target.attr('data-target');
        const targetLevel = $target.attr('data-level') || 0;

        $('.show-details.active').removeClass('active');
        $target.addClass('active');

        $('.map-pin.active').removeClass('active');
        if (targetID && targetID.length) {
            $('#'+targetID).addClass('active');
        }

        $('.store-map.active').removeClass('active');
        $('.store-map.map-level-'+targetLevel).addClass('active');
    };

    // $('[data-show-level]').each(function(){
    //     const $mapContainer = $(this).closest('map-container')
    //     $mapContainer.removeClass('active');
    // });
    $('[data-show-level]').click(function () {
        $('.map-pin').removeClass('active');
        $('.map-container').removeClass('active');
        $('.map-level-' + $(this).attr('data-show-level')).addClass('active');
    });

    $('.digital-directory .centre-map-pg select').on('change', showMap);

    $('.show-details').on('mouseenter', showMap);

    $('.store-search input').bind('keyup', function() {

        var searchString = $(this).val();

        if ( !searchString ) {
            $('.store-filter .nav').show();
            $('.store-filter .tab-content').removeClass('search-active');
            $(".store-filter .tab-content .show-details .storeName").each(function() {
                $(this).parent('.show-details').show();
            });
        } else {
            $('.store-filter .nav .nav-item:first-child .nav-link').tab('show');
            $('.store-filter .nav').hide();
            $('.store-filter .tab-content').addClass('search-active');

            let stores = [];
            $(".store-filter .tab-content .show-details .storeName").each(function(index, value) {
                const currentName = $(value).text();
                if( currentName.toUpperCase().indexOf(searchString.toUpperCase()) > -1) {
                    if(!stores.includes(currentName)) {
                        $(value).parent('.show-details').show();
                        stores.push(currentName);
                    } else {
                        $(value).parents('.show-details').hide();
                    }
                } else {
                    $(value).parents('.show-details').hide();
                }
            });
        }

    });
});
